import { render, staticRenderFns } from "./SClientesPlanos.vue?vue&type=template&id=2b5854fa&scoped=true"
import script from "./SClientesPlanos.vue?vue&type=script&lang=js"
export * from "./SClientesPlanos.vue?vue&type=script&lang=js"
import style0 from "./SClientesPlanos.vue?vue&type=style&index=0&id=2b5854fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5854fa",
  null
  
)

export default component.exports